export default e => window.documentViewer.getAnnotationManager().getAnnotationByMouseEvent(e);